import fse from 'fs-extra';
import path from 'path';

export const isFile = (item: string) => !!path.extname(item);

export const isDirectory = (item: string) => !isFile(item);

export const directoryExists = async (currentWorkingDirectory: string = process.cwd()) => {
  const currentWorkingDirectoryPath = path.resolve(currentWorkingDirectory);
  return fse.existsSync(currentWorkingDirectoryPath);
};

export const joinPath = (currentWorkingDirectory: string, childPath: string = '') => `${currentWorkingDirectory.replace(/\/+$/g, '')}/${childPath}`;
